var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusInitializing = function SvgStatusInitializing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#24CD2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.824 4.516a1 1 0 0 1 1.16.808l.536 2.991a1 1 0 0 1-.615 1.105l-2.535 1.01a1 1 0 1 1-.74-1.859l.74-.295A4 4 0 0 0 12 8.038 4 4 0 0 0 9.169 9.2 3.93 3.93 0 0 0 8 12.001a1 1 0 1 1-2 0c0-1.65.675-3.142 1.76-4.22A6 6 0 0 1 12 6.038c.758 0 1.483.14 2.151.395l-.135-.757a1 1 0 0 1 .808-1.16M17 11a1 1 0 0 1 1 1 5.93 5.93 0 0 1-1.76 4.219A6 6 0 0 1 12 17.962c-.758 0-1.483-.14-2.151-.394l.135.756a1 1 0 1 1-1.968.352l-.536-2.99a1 1 0 0 1 .615-1.106l2.535-1.009a1 1 0 1 1 .74 1.858l-.74.295c.426.154.888.239 1.37.239a4 4 0 0 0 2.831-1.164A3.93 3.93 0 0 0 16 12a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgStatusInitializing;